var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPromoteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.994,
    height: 22.002,
    viewBox: "0 0 22.994 22.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12919",
    "data-name": "Group 12919",
    transform: "translate(383.999 826)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45257",
    "data-name": "Path 45257",
    d: "M82.207,50.17l-3.174-5.48c.41-.349.826-.671,1.207-1.031a11.687,11.687,0,0,0,2.328-3.275c.436-.858.859-1.723,1.282-2.587a.712.712,0,0,1,1.321-.047q3.052,5.283,6.111,10.561a.727.727,0,0,1,.039.808.714.714,0,0,1-.721.32c-1.2-.072-2.4-.159-3.608-.2a9.957,9.957,0,0,0-4.653.889,1.048,1.048,0,0,1-.131.04",
    transform: "translate(-457.986 -860.941)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45258",
    "data-name": "Path 45258",
    d: "M4,161.836,7.166,167.3c-.012.021-.016.04-.028.047-.856.493-1.693,1.022-2.572,1.468a3.166,3.166,0,0,1-3.017-5.56c.808-.479,1.626-.94,2.452-1.416",
    transform: "translate(-384 -977.503)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45259",
    "data-name": "Path 45259",
    d: "M92.153,265.326l1.877-1.081a.567.567,0,0,1,.064.074c.658,1.135,1.322,2.267,1.97,3.408a1.082,1.082,0,0,1-.669,1.612,1.047,1.047,0,0,1-1.169-.449c-.7-1.176-1.377-2.363-2.074-3.564",
    transform: "translate(-470.268 -1073.373)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45260",
    "data-name": "Path 45260",
    d: "M286.56,58.582a.613.613,0,0,1-.643-.415.569.569,0,0,1,.255-.681c.345-.213.7-.41,1.051-.613s.729-.424,1.1-.63a.6.6,0,0,1,.873.186.6.6,0,0,1-.273.848q-1.041.607-2.09,1.2a1.586,1.586,0,0,1-.271.105",
    transform: "translate(-651.631 -878.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45261",
    "data-name": "Path 45261",
    d: "M246.049,2.668a1.558,1.558,0,0,1,.108-.283q.578-1.015,1.17-2.022a.6.6,0,1,1,1.039.586q-.59,1.035-1.194,2.063a.582.582,0,0,1-.689.3.619.619,0,0,1-.433-.639",
    transform: "translate(-614.338 -826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45262",
    "data-name": "Path 45262",
    d: "M304.561,132.612c-.431,0-.862.012-1.293,0a.547.547,0,0,1-.519-.452.569.569,0,0,1,.269-.635.767.767,0,0,1,.341-.089q1.2-.011,2.395,0a.6.6,0,1,1,0,1.189c-.4.01-.8,0-1.2,0v-.009",
    transform: "translate(-667.405 -949.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45263",
    "data-name": "Path 45263",
    d: "M227.713,94.8l-1.7-2.943a1.68,1.68,0,0,1,2.132.612,1.714,1.714,0,0,1-.428,2.331",
    transform: "translate(-595.578 -911.824)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoteIcon);
export default __webpack_public_path__ + "static/media/promote_icon.8c672ab70f5740e6badb8ebc98f3f0c5.svg";
export { ForwardRef as ReactComponent };